module.exports = __webpack_public_path__ + "img/cast_ic_hackathon.d8ed7d81.svg";